import React, { useEffect, useState } from "react";
import styles from "./AdminViewAnswerSheet.module.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AxiosInstance } from "../../../../../../../axios";
import moment from "moment";
import { Download } from "@mui/icons-material";
import { Visibility } from "@mui/icons-material";
import { ImageUrlPrefix } from "../../../../../../../labels";

function AdminViewAnswerSheet() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [fldata, setFldata] = useState({
    student_name: "",
    overall_rank: "",
    batch_name: "",
    batch_id: "",
    course_name: "",
    sub_category: "",
    category: "",
    exam_name: "",
    date_of_exam: "",
    medium_of_instruction: "",
    medium_of_instruction_name: "",
    answersheet_path: null,
    answersheet_original_path: null,
    batch_range_from: "",
    batch_range_to: "",
  });

  const [subTopic, setSubTopic] = useState([]);
  const [appBatch, setAppBatch] = useState([]);
  useEffect(() => {
    if (id) {
      try {
        AxiosInstance.post("api/test/descriptive/topper_view", { id })
          .then((res) => {
            if (res.data.status === true) {
              if (res.data.data.length > 0) {
                const lsv = res.data.data;
                setFldata({
                  student_name: lsv[0]?.student_name || "",
                  overall_rank: lsv[0]?.over_all_rank || "",
                  batch_name: lsv[0]?.batch_name || "",
                  batch_id: lsv[0]?.batch_id || "",
                  exam_name: lsv[0]?.exam_name || "",
                  date_of_exam: lsv[0]?.exam_date
                    ? moment(lsv[0].exam_date).format("DD/MM/YYYY")
                    : "",
                  medium_of_instruction:
                    lsv[0]?.medium === 0
                      ? lsv[0]?.medium
                      : lsv[0]?.medium || "",
                  medium_of_instruction_name:
                    lsv[0]?.medium === 1 ? "English" : "Tamil",
                  answersheet_path: lsv[0]?.answer_sheet_path || null,
                  answersheet_original_path:
                    lsv[0]?.answer_sheet_original_path || null,
                  batch_range_from: lsv[0]?.from_date
                    ? moment(lsv[0].from_date).format("DD/MM/YYYY")
                    : "",
                  batch_range_to: lsv[0]?.to_date
                    ? moment(lsv[0].to_date).format("DD/MM/YYYY")
                    : "",
                  category: lsv[0]?.category_name || "",
                  sub_category: lsv[0]?.sub_category_name || "",
                  course_name: lsv[0]?.course_name || "",
                });
                const transformedSubTopic = lsv[0]?.subject
                  ? lsv[0]?.subject
                  : [];
                setSubTopic(transformedSubTopic);
                const AppBt =
                  lsv[0]?.applicable_batch?.length > 0
                    ? lsv[0].applicable_batch
                    : [];
                setAppBatch(AppBt);
              }
            }
          })
          .catch((error) => {
            return error;
          });
      } catch (error) {
        console.error("Error fetching topper view data:", error);
      }
    }
  }, [id]);

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  const handleNavigateEdit = (EDITID) => {
    navigate(`/UploadAnswerSheet/${EDITID}`);
  };
  return (
    <div>
      <div
        className={`${styles.ViewAdminStudent} global_container container-fluid BathHeader`}
      >
        <div className="row ">
          <div className=" col-md-6 col-12 ">
            <h6 className="TitleHeader "> View Answer Sheet </h6>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  to={`javascript:void(0)`}
                  onClick={navigateToPreviousScreen}
                  className="secondaryButton "
                >
                  Back to Top Performer Answer Sheets
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  onClick={() => handleNavigateEdit(id)}
                  to={"javascript:void(0)"}
                  className={`primaryButton `}
                  variant="primary"
                >
                  <span className="material-icons me-1 fs-5 align-middle text-white">
                    border_color
                  </span>
                  Edit Answer Sheet
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <section className={styles.StepOne}>
              <div className={`${styles.box} row`}>
                <div className="col-md-12">
                  <p className={styles.StepTitle}>Answer Sheet Details</p>
                  <div className="row mb-3">
                    <div className="col-md-3">
                      <div className={styles.forms}>
                        <label
                          htmlFor="inputName"
                          className="form-label text-muted "
                        >
                          Student Name
                        </label>
                        <span className={styles.ReviewLabel}>
                          {fldata.student_name || "_"}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className={styles.forms}>
                        <label
                          htmlFor="inputName"
                          className="form-label text-muted "
                        >
                          Overall Rank
                        </label>
                        <span className={styles.ReviewLabel}>
                          {fldata.overall_rank || "_"}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className={styles.forms}>
                        <label
                          htmlFor="inputName"
                          className="form-label text-muted "
                        >
                          Batch Name
                        </label>
                        <span className={styles.ReviewLabel}>
                          {fldata.batch_name || "_"}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className={styles.forms}>
                        <label
                          htmlFor="inputName"
                          className="form-label text-muted "
                        >
                          Exam Name
                        </label>
                        <span className={styles.ReviewLabel}>
                          {fldata.exam_name || "_"}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className={styles.forms}>
                        <label
                          htmlFor="inputName"
                          className="form-label text-muted "
                        >
                          Medium of Instruction
                        </label>
                        <span className={styles.ReviewLabel}>
                          {fldata.medium_of_instruction_name || "_"}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className={styles.forms}>
                        <label
                          htmlFor="inputName"
                          className="form-label text-muted "
                        >
                          Date of Exam
                        </label>
                        <span className={styles.ReviewLabel}>
                          {fldata.date_of_exam || "_"}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className={styles.forms}>
                        <label
                          htmlFor="inputName"
                          className="form-label text-muted "
                        >
                          Answer Sheet{" "}
                          {fldata.answersheet_path !== "" &&
                            fldata.answersheet_path !== null && (
                              <a
                                target="_blank"
                                href={`${ImageUrlPrefix}/${fldata.answersheet_path}`}
                                style={{ marginTop: "15px" }}
                              >
                                <Download className="download_icon" />
                                <Visibility className="download_icon" />
                              </a>
                            )}
                        </label>
                        <span className={styles.ReviewLabel}>
                          {fldata.answersheet_original_path || "_"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className={styles.StepOne}>
              <div className={`${styles.box} row`}>
                <div className="col-md-12">
                  <p className={styles.StepTitle}>Subjects and Topics</p>
                  {subTopic.length > 0 &&
                    subTopic.map((fo) => (
                      <div className="row mb-3">
                        <div className="col-md-3">
                          <div className={styles.forms}>
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Subject
                            </label>
                            <span className={styles.ReviewLabel}>
                              {fo.subject || "_"}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-9">
                          <div className={styles.forms}>
                            <label
                              htmlFor="inputName"
                              className="form-label text-muted "
                            >
                              Test Topics
                            </label>
                            <span className={styles.ReviewLabel}>
                              {(fo.test_topics &&
                                fo.test_topics
                                  .map((topic) => topic.test_topic_name)
                                  .join(", ")) ||
                                "_"}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </section>

            <section className={styles.StepOne}>
              <div className={`${styles.box} row`}>
                <div className="col-md-12">
                  <p className={styles.StepTitle}>Applicable Batches</p>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <div className={styles.forms}>
                        <label
                          htmlFor="inputName"
                          className="form-label text-muted "
                        >
                          Applicable Batches
                        </label>
                        <span className={styles.ReviewLabel}>
                          {(appBatch.length > 0 &&
                            appBatch.map((ba) => ba.name).join(", ")) ||
                            "_"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminViewAnswerSheet;
